import { createContext, useContext, useState, useEffect } from 'react';
import api from '../services/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    const token = localStorage.getItem('token');
    if (token) {
      try {
        const res = await api.get('/me');
        setUser(res.data.company);
      } catch (error) {
        localStorage.removeItem('token');
        localStorage.removeItem('token_expires_at');
        localStorage.removeItem('company');
        localStorage.removeItem('punto_venta_id');
        setUser(null);
      }
    }
    setLoading(false);
  };

  const login = async (email, password) => {
    const res = await api.post('/login', { email, password });
    
    console.log('Login response:', res.data); // LOG TEMPORAL
    
    const { token, company, puntos_venta } = res.data;
    
    localStorage.setItem('token', token);
    localStorage.setItem('token_expires_at', res.data.expires_at);
    localStorage.setItem('company', JSON.stringify(company));
    
    if (puntos_venta.length === 1) {
      localStorage.setItem('punto_venta_id', puntos_venta[0].id);
    }
    
    setUser(company);
    
    return res.data;
  };

  const logout = async () => {
    try {
      await api.post('/logout');
    } catch (error) {
      console.error('Error al cerrar sesión:', error);
    } finally {
      localStorage.removeItem('token');
      localStorage.removeItem('token_expires_at');
      localStorage.removeItem('company');
      localStorage.removeItem('punto_venta_id');
      setUser(null);
    }
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth debe usarse dentro de AuthProvider');
  }
  return context;
};